
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/funnels/[funnelId]",
      function () {
        return require("private-next-pages/funnels/[funnelId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/funnels/[funnelId]"])
      });
    }
  